import React, { useEffect, useState } from 'react'
import cn from 'classnames'

import useIntersectionObserver from '../../../utils/hooks/useInterSectionObserver'
import { Heading } from '../../Typography/Heading/Heading'
import { VariantGroupsList } from '../VariantGroupsList'
import { SkeletonLoader } from '../SkeltonLoader'

const InfiniteVariantList = ({
  searchQuery,
  handleUpdatePageNumber,
  pageNumber,
  fetchVariantList,
  selectedContentTypeName,
  onClickHandler,
  batchSize,
  setVariantListData,
  variantListData,
  setVariantName,
  closeModal,
  isListDisabled,
  isListPage,
  multiSelectTag,
  variantTags,
  setVariantTags,
  disableNonCreatedVariant
}: any) => {
  const [loading, setLoading] = useState(false)
  // const [variantListData, setVariantListData]: any = useState([])
  const [totalVariantGroup, setTotalVariantGroups] = useState<number | null>()

  let lastElementRef
  if (!isListPage) {
    const observerCallBack = (): void => {
      if (!loading && variantListData.length && pageNumber < Math.ceil(totalVariantGroup / batchSize)) {
        const calculatedPageNumber =
          variantListData.length && pageNumber < Math.ceil(totalVariantGroup / batchSize) ? pageNumber + 1 : pageNumber
        handleUpdatePageNumber({ pageNumber: calculatedPageNumber })
      }
    }
    lastElementRef = useIntersectionObserver(observerCallBack, {}, [loading, totalVariantGroup])
  }

  const fetchData = async (skip, limit, searchQuery, signal) => {
    setLoading(true)
    try {
      const response: any = await fetchVariantList({ skip, limit, searchQuery, signal })
      if (response) {
        setVariantListData((prevResponse) => {
          return [...prevResponse, ...response.variant_groups]
        }) // Update state with the data
        setTotalVariantGroups(response.count)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error('Error fetching variant list:', error)
    }
  }

  useEffect(() => {
    if (isListPage) return
    setVariantListData([])
  }, [searchQuery])

  const abortController = new AbortController()
  useEffect(() => {
    if (isListPage) return
    const skip = !variantListData.length && pageNumber ? 0 : pageNumber * batchSize - batchSize
    const limit = batchSize
    if (skip < totalVariantGroup || skip === 0) {
      fetchData(skip, limit, searchQuery, abortController?.signal)
    }

    //cleanup function where we cancelling unnecessary req when component unmounts
    return () => {
      abortController?.abort()
    }
  }, [pageNumber, searchQuery])

  const clickableBaseclassname = cn({ 'VariantList__variant__label--clickable': onClickHandler })

  const onVariantClickHandler = (variant) => {
    if (!multiSelectTag) {
      closeModal()
      // setVariantName(variant.name)
      if (onClickHandler) {
        onClickHandler(variant.uid)
      }
    }
  }

  return (
    <>
      {isListPage ?
        <VariantGroupsList variantListData={variantListData} clickableBaseclassname={clickableBaseclassname} onVariantClickHandler={onVariantClickHandler} disableNonCreatedVariant={disableNonCreatedVariant} />
        :
        <VariantGroupsList
          lastElementRef={lastElementRef}
          variantListData={variantListData}
          selectedContentTypeName={selectedContentTypeName}
          clickableBaseclassname={clickableBaseclassname}
          onVariantClickHandler={onVariantClickHandler}
          isListDisabled={isListDisabled}
          variantTags={variantTags}
          setVariantTags={setVariantTags}
          multiSelectTag={multiSelectTag}
          onClickHandler={onClickHandler}
          disableNonCreatedVariant={disableNonCreatedVariant}
        />}
      {loading && <div className='variantList__loading__wrapper' >
        <SkeletonLoader size={variantListData?.length ? 2 : 10} testId='cs-variant-loader' />
      </div>}
      {!variantListData.length && !loading && (
        <Heading
          tagName="h5"
          text={searchQuery ? 'No results found' : 'No variants available'}
          className="VariantList__empty-state"
          testId="cs-variant-no-search-result"
        />
      )}
    </>
  )
}

export default InfiniteVariantList
